import React, { useMemo } from "react";
import "./InvoiceModal.scss";
// import { useDispatch } from "react-redux";
// import { fetchCandidateTransactionDetails } from "../../../redux/actions/CompanyBillingDetailsAction";

function InvoiceModal({ selectedOption, data, setOpenModal }) {
  // const dispatch = useDispatch();
  // const [transactionDetails, setTransactionDetails] = useState([]);
  console.log('data ------------ ', data);
  const splitChecks = data?.client_checks?.split_value;
  const listofChecks =
  selectedOption.toLowerCase() === "invoice"
    ? data?.client_checks?.split_value
    : selectedOption.toLowerCase() === "transaction" ? data?.service_apicheck : selectedOption.toLowerCase() === 'wallet' && data?.wallet_receipts?.check_id ;

      const totalPrice = useMemo(() => {
        const totalValue = data?.wallet_receipts?.check_id?.reduce(
          (acc, val) => acc + (val.valiant_rate_tax || 0), 
          0
        ) ?? 0;
        
        return totalValue;
      }, [data?.wallet_receipts?.check_id]); 
    

      const invoiceTotal = useMemo(() => {
        const splitValue = data?.client_checks?.split_value
        if(splitValue){
          const totalValue = Object.keys(splitValue)?.reduce(
            (acc, val) => acc + (splitValue[val]?.cost || 0), 
            0
          ) ?? 0;
          return totalValue;
        }
      },[data?.client_checks?.split_value])
        
  // const callfetchCandidateTransactionDetails = () => {
  //   data = {
  //     order_id: data?.order_id,
  //   };
  //   const successFn = (res) => setTransactionDetails(res.data);
  //   const failureFn = (err) => console.log(err);
  //   dispatch(fetchCandidateTransactionDetails({ data, successFn, failureFn }));
  // };
  // useEffect(() => {
  //   if (selectedOption !== "Invoice") callfetchCandidateTransactionDetails();
  // }, []);
  // const candidateDetails =
  //   selectedOption !== "Invoice" ? transactionDetails?.candidate_details[0] : {};

  return (
    <div className='modalBackGround' onClick={() => setOpenModal(false)}>
    <div className='modalContainer' onClick={e => e.stopPropagation()}>
      {selectedOption.toLowerCase() === "invoice" ? (
        <>
          <h1>
            Billing Breakdown
            {/* <button className="closeBtn" onClick={() => setOpenModal((prev) => !prev)}>
            Close
        </button> */}
          </h1>
          <div className='invoiceDetails'>
            <div>
              <p>Invoice Id</p>
              <p>{data?.client_invoice_id ? data?.client_invoice_id : '--'}</p>
            </div>
            {/* <div>
              <p>Payment Span</p>
              <p>{data?.paymentSpan}</p>
            </div> */}
            <div>
              <p>Invoice Date</p>
              <p>{data?.created_at ? data?.created_at?.slice(0,10) : '--'}</p>
            </div>
            <div>
              <p>Payment Status</p>
              <p className='status'>{data.is_paid === 1 ? "Paid" : "Unpaid"}</p>
            </div>
            <div>
              <p>Payment Mode</p>
              <p>Post Paid</p>
            </div>
          </div>
          <div className='userDetails'>
            {Object.keys(listofChecks)?.map((check) => (
              <>
                <div>
                  <p>{check}</p>
                  <p>₹ {listofChecks[check]?.cost}</p>
                </div>
              </>
            ))}
          </div>
          <div className='inVoiceTotal'>
            <p>Total</p>
            <p>₹ {invoiceTotal}</p>
          </div>
          <button onClick={() => setOpenModal((prev) => !prev)}>Done</button>
        </>
      ) :
      selectedOption.toLowerCase() === "transaction" ?
      (
        <>
          <h1>
            Billing Breakdown
            {/* <button className="closeBtn" onClick={() => setOpenModal((prev) => !prev)}>
            Close
        </button> */}
          </h1>
          <div className='transactionDetails'>
            <div>
              <p>Candidate Name</p>
              <p>{`${data?.candidate_details?.[0]?.first_name} ${data?.candidate_details?.[0]?.last_name}`}</p>
            </div>
            <div>
              <p>Job Seeker ID</p>
              <p>{data?.candidate_details?.[0]?.job_seeker_id ? data?.candidate_details?.[0]?.job_seeker_id : '--'}</p>
            </div>
            <div>
              <p>Work Order ID</p>
              <p>{data?.candidate_details?.[0]?.work_order_id ? data?.candidate_details?.[0]?.work_order_id : '--'}</p>
            </div>
          </div>
          <div className='transactionDetails'>
            <div>
              <p>Transaction ID</p>
              <p>{data?.razor_transaction_id ? data?.razor_transaction_id : '--'}</p>
            </div>
            {/* <div>
              <p>Payment Method</p>
              <p>{data?.paymentMethod}</p>
            </div> */}
            <div>
              <p>Transaction Date</p>
              <p>
                {data?.created_at ? 
                  data?.created_at?.slice(0,10)
                  :
                  '--'
                }
              </p>
            </div>
            <div>
              <p>Payment Status</p>
              <p className='status'>{data.payment_status ? data.payment_status : '--'}</p>
            </div>
            <div>
              <p>Payment Mode</p>
              <p>Prepaid</p>
            </div>
          </div>
          <div className='userCredentials'>
            {listofChecks?.map((check) => (
                <div>
                  <p>{check.display_name}</p>
                  <p>₹ {check.valiant_rate_tax}</p>
                </div>
            ))}
          </div>
          <div className='transactionTotal'>
            <p>Total</p>
            <p>₹ {data?.total_amount ? data?.total_amount : '--'}</p>
          </div>
          <button onClick={() => setOpenModal((prev) => !prev)}>Done</button>
        </>
      ) :
      selectedOption.toLowerCase() === "wallet" && (
        <>
            <h1>
              Billing Breakdown
            </h1>
            <div className='transactionDetails'>
            {data?.wallet_receipts?.candidate_name && 
              <div>
                <p>Candidate Name</p>
                <p>{data?.wallet_receipts?.candidate_name ? data?.wallet_receipts?.candidate_name : '--'}</p>
              </div>
            }
              <div>
                <p>Wallet Transaction ID</p>
                <p>{data?.wallet_transaction_id ? data?.wallet_transaction_id : '--'}</p>
              </div>
              <div>
                <p>Transaction Date</p>
                {/* <p>
                  {new Date(
                    data?.transaction_date
                  ).toLocaleDateString()}
                </p> */}
                <p>
                  {data?.transaction_date ? data?.transaction_date?.slice(0,20) : data?.created_at?.slice(0,20)}
                </p>
              </div>
              <div>
                <p>Payment Status</p>
                <p className='status'>{data?.payment_status ? data?.payment_status : '--'}</p>
              </div>
            </div>
            <div className='userCredentials'>
              {listofChecks?.map((check) => (
                  <div>
                    <p>{check?.display_name}</p>
                    <p>₹ {check?.valiant_rate_tax}</p>
                  </div>
              ))}
            </div>
            <div className='transactionTotal'>
              <p>Total</p>
              <p>₹ {data?.wallet_credit_debit_amt}</p>
            </div>
            <button onClick={() => setOpenModal((prev) => !prev)}>Done</button>
          </>)
        }
        </div>
      </div>
    );
}

export default InvoiceModal;
